import classNames from 'classnames';

import useStyles from './styles';

function InteractiveImages() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={classNames(styles.title, 'skeleton')}>
        <i className="skeleton" />
      </div>
      <div className={classNames(styles.description, 'skeleton')}>
        <i className="skeleton" />
      </div>
      <div className="skeleton">
        <i className="skeleton" />
      </div>
    </div>
  );
}

export default InteractiveImages;
